export const VALID_PROMPT_KEYWORDS = [
  'business',
  'finance',
  'revenue',
  'cost',
  'profit',
  'loss',
  'growth',
  'trend',
  'forecast',
  'analysis',
  'performance',
  'metric',
  'kpi',
  'target',
  'goal',
  'budget',
  'expense',
  'risk',
  'opportunity',
  'strategy',
  'market',
  'customer',
  'product',
  'service',
  'operation',
  'efficiency',
  'productivity',
  'quality',
  'compliance',
  'regulation',
  'audit',
  'report',
  'dashboard',
  'visualization',
  'chart',
  'graph',
  'data',
  'insight',
  'recommendation',
  // Additional keywords from EnhancedAISummaryBox
  'ticket',
  'tickets',
  'issue',
  'issues',
  'bug',
  'bugs',
  'incident',
  'incidents',
  'user',
  'users',
  'application',
  'applications',
  'app',
  'apps',
  'analytics',
  'reporting',
  'usage',
  'engagement',
  'activity',
  'patterns',
  'resolution',
  'resolve',
  'severity',
  'priority',
  'status',
  'workflow',
  'summary',
  'analyze',
  'statistics',
  'stats',
  'count',
  'total',
  'average',
  'percentage',
  'rate',
  'time',
  'duration',
  'monthly',
  'weekly',
  'daily',
  'quarterly',
  'period',
  'date',
  'range'
];

export const RESTRICTED_PROMPT_KEYWORDS = [
  'personal',
  'private',
  'confidential',
  'secret',
  'sensitive',
  'inappropriate',
  'offensive',
  'harmful',
  'malicious',
  'dangerous',
  'illegal',
  'unethical',
  // Additional restricted keywords from EnhancedAISummaryBox
  'weather',
  'sports',
  'politics',
  'news',
  'entertainment',
  'movie',
  'music',
  'recipe',
  'cooking',
  'travel',
  'vacation',
  'stock',
  'investment',
  'crypto',
  'bitcoin'
];

export const SUMMARY_ENHANCEMENT_PROMPT_TEMPLATE = `
Please enhance this business summary with the following considerations:
1. Focus on key business metrics and trends
2. Highlight significant patterns and insights
3. Provide actionable recommendations
4. Use clear and professional business language
5. Maintain data confidentiality and compliance

Original Summary:
{summary}

Additional Context:
- Business Area: {businessArea}
- Time Period: {timePeriod}
- Key Metrics: {metrics}
`;

export const AI_OPTIMIZATION_PROMPT_TEMPLATE = `
CUSTOM ANALYSIS REQUEST: {customPrompt}

INSTRUCTIONS FOR AI:
- Provide a comprehensive, detailed analysis similar to standard business reporting summaries
- Include specific metrics, percentages, and quantitative insights where available
- Structure the response with clear sections and bullet points
- Provide actionable insights and key findings
- Use HTML formatting for better readability (headings, lists, emphasis)
- Aim for the same depth and detail level as regular business summaries
- Include trend analysis and comparative insights where relevant

DATA CONTEXT: This analysis should be based on the provided business data and current filter selections.
`;

export const ENHANCE_SUMMARY_PROMPT_TEMPLATE = `
CUSTOM ANALYSIS REQUEST: {customPrompt}

EXISTING SUMMARY TO ENHANCE: {truncatedSummary}

INSTRUCTIONS FOR AI:
- Enhance the existing summary with focus on the custom request
- Provide comprehensive, detailed analysis similar to standard business reporting summaries
- Include specific metrics, percentages, and quantitative insights where available
- Structure the response with clear sections and bullet points
- Provide actionable insights and key findings
- Use HTML formatting for better readability (headings, lists, emphasis)
- Aim for the same depth and detail level as regular business summaries
- Include trend analysis and comparative insights where relevant

DATA CONTEXT: This analysis should be based on the provided business data and current filter selections.
`;

export const SUMMARY_MAX_LENGTH = 2000;

export const CHART_TYPES = {
  LINE: 'line',
  BAR: 'bar',
  PIE: 'pie',
  MULTI: 'multi'
} as const;

export const CHART_DEFAULTS = {
  HEIGHT: 300,
  WIDTH: 600,
  MARGIN: {
    TOP: 20,
    RIGHT: 30,
    BOTTOM: 40,
    LEFT: 50
  }
};
